import React from "react";
import "./ForgotPassword.scss";
import { withRouter } from "react-router-dom";
import ResetPasswordEmail from "./ResetPasswordEmail/ResetPasswordEmail";
import ResetPasswordAccount from "./ResetPasswordAccount/ResetPasswordAccount";

const queryString = require("query-string");

const ForgotPassword = (props) => {
  const params = queryString.parse(props.location.search);

  if (params.key) {
    return <ResetPasswordAccount resetKey={params.key} login={params.login} />;
  }

  return <ResetPasswordEmail />;
};

export default withRouter(ForgotPassword);
